import { render, staticRenderFns } from "./PDResourceCollection.vue?vue&type=template&id=0265e12d"
import script from "./PDResourceCollection.vue?vue&type=script&lang=js"
export * from "./PDResourceCollection.vue?vue&type=script&lang=js"
import style0 from "./PDResourceCollection.vue?vue&type=style&index=0&id=0265e12d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports